import { ActionRedo } from '@robotsnacks/icons';
import { Quill } from 'quill';
import React, { SFC } from 'react';
import ToolbarButton from '../ToolbarButton';

export type RedoButtonProps = {
  quill: Quill;
};

const RedoButton: SFC<RedoButtonProps> = ({ quill }) => (
  <ToolbarButton
    onMouseDown={e => {
      e.preventDefault();
      (quill as any).history.redo();
    }}
  >
    <ActionRedo />
  </ToolbarButton>
);

export default RedoButton;
